// extracted by mini-css-extract-plugin
module.exports = {"header":"blog-module--header--3AMSV","date":"blog-module--date--147vx"};